import ServiceTemplate from '@/components/ServiceTemplate';

export default function TTABPetition() {
  const data = {
    title: 'TTAB Opposition and Cancellation Services',
    subtitle: 'Expert representation in Trademark Trial and Appeal Board proceedings.',
    overviewTitle: 'Understanding TTAB Proceedings',
    overviewImage: 'https://images.unsplash.com/photo-1757353614837-d8085c4fdbd6',
    description: [
      'The Trademark Trial and Appeal Board (TTAB) hears opposition and cancellation proceedings regarding trademark applications and registrations. These are complex legal proceedings requiring specialized expertise.',
      'Opposition proceedings challenge trademark applications before registration, while cancellation proceedings seek to cancel existing registrations. Both require strategic planning and skilled legal advocacy.',
      'Our experienced trademark litigation attorneys represent clients in all phases of TTAB proceedings, from filing petitions through trial and appeals.'
    ],
    benefits: [
      { title: 'Specialized Expertise', description: 'Attorneys experienced in TTAB procedures and strategy.' },
      { title: 'Strategic Planning', description: 'Comprehensive case strategy to maximize success.' },
      { title: 'Discovery Management', description: 'Effective discovery to build strong cases.' },
      { title: 'Trial Advocacy', description: 'Skilled presentation of evidence and arguments.' },
      { title: 'Settlement Negotiation', description: 'Pursue favorable settlements when appropriate.' },
      { title: 'Appeal Rights', description: 'Full representation through appeals if necessary.' }
    ],
    process: [
      { title: 'Analysis & Strategy', description: 'Thorough review of issues and development of comprehensive response strategy.' },
      { title: 'Response Preparation & Filing', description: 'Expert drafting and timely filing of all required responses and documentation.' },
      { title: 'Follow-Up & Resolution', description: 'Monitoring progress and ensuring successful resolution of all matters.' }
    ],
    pricing: [
      {
        name: 'Basic',
        description: 'Essential trademark filing',
        price: '$599',
        period: '+ USPTO fees ($250-$350)',
        features: [
          'Preliminary trademark search',
          'Single class filing',
          'USPTO application preparation',
          'Filing with USPTO',
          'Email support',
          'Status monitoring'
        ]
      },
      {
        name: 'Professional',
        description: 'Complete trademark package',
        price: '$999',
        period: '+ USPTO fees',
        featured: true,
        features: [
          'Everything in Basic',
          'Comprehensive search report',
          'Multi-class discounts available',
          'Office action response (1 included)',
          'Priority processing',
          'Trademark monitoring (6 months)',
          'Phone & email support'
        ]
      },
      {
        name: 'Premium',
        description: 'Full-service trademark protection',
        price: '$1,499',
        period: '+ USPTO fees',
        features: [
          'Everything in Professional',
          'Global trademark search',
          'Unlimited office action responses',
          'International filing coordination',
          'Trademark monitoring (12 months)',
          'Enforcement support',
          'Dedicated attorney access'
        ]
      }
    ],
    faqs: [
      { question: 'What is an opposition?', answer: 'An opposition is a proceeding to oppose registration of a trademark application before it becomes a registration.' },
      { question: 'Who can file an opposition?', answer: 'Anyone who believes they would be damaged by registration of a mark can file, typically owners of conflicting marks.' },
      { question: 'What are grounds for cancellation?', answer: 'Grounds include abandonment, fraud, genericness, likelihood of confusion, and failure to function as a trademark.' },
      { question: 'How long do TTAB proceedings take?', answer: 'Opposition and cancellation proceedings typically take 1-2 years from filing to final decision, longer if appeals are involved.' },
      { question: 'What is the deadline to oppose?', answer: 'Oppositions must be filed within 30 days after publication, though extensions of up to 180 days are available.' },
      { question: 'Can we settle an opposition?', answer: 'Yes, many oppositions settle through consent agreements, coexistence agreements, or withdrawal arrangements.' },
      { question: 'How much does TTAB litigation cost?', answer: 'Costs typically range from $10,000-$50,000+ depending on case complexity and whether it proceeds through trial.' },
      { question: 'Can I appeal a TTAB decision?', answer: 'Yes, TTAB decisions can be appealed to the Federal Circuit Court of Appeals or by filing a civil action in district court.' }
    ]
  };

  return <ServiceTemplate {...data} />;
}
